import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";

const getProjectDiskUsage = {
    namespaced: true,
    state: {
        projectDiskCapacityInMb: null,
        projectDiskUsageInMb: null,
        projectDiskUsageInPercents: null,
    },
    mutations: {
        GET_PROJECT_DISK_USAGE_SUCCESS(state, response) {
            state.projectDiskCapacityInMb = response.data.data.diskUsage.capacity;
            state.projectDiskUsageInMb = response.data.data.diskUsage.usedUp;
            state.projectDiskUsageInPercents = (response.data.data.diskUsage.usedUp * 100 / response.data.data.diskUsage.capacity).toFixed(2);
        },
        GET_PROJECT_DISK_USAGE_FAILURE(state, error) {
            console.log(error);
        }     
    },
    actions: {
        getProjectDiskUsageRequest({dispatch}) {
            const urlParams = new URLSearchParams(window.location.search);
            let promise = sendRequest("get", config.baseURLApi + "/projects/" + urlParams.get("id") + '/diskUsage');
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetProjectDiskUsage", result[1]);
                } else {
                    dispatch("failureGetProjectDiskUsage", result[1]);
                }
            });
        },
        successGetProjectDiskUsage({ commit }, response) {
            commit("GET_PROJECT_DISK_USAGE_SUCCESS", response);
        },
        failureGetProjectDiskUsage({ commit }, error) {
            commit("GET_PROJECT_DISK_USAGE_FAILURE", error);
        },
    }
}

export default getProjectDiskUsage;